import ReactDatePicker from 'react-datepicker';

interface Props {
  startDate: Date | null;
  endDate: Date | null;
  onChangeDates?: any;
  label?: string;
  required?: boolean;
}

export default function DateRangePicker({
  startDate,
  endDate,
  onChangeDates,
  label,
  required = false,
}: Props) {
  return (
    <div>
      <label className='form-label labelText'>
        {label} {required ? <span style={{ color: 'red' }}>*</span> : ''}
      </label>
      <ReactDatePicker
        className='form-control ubbe-input DateRange'
        selected={startDate}
        startDate={startDate}
        endDate={endDate}
        onChange={onChangeDates}
        placeholderText='Select dates'
        dateFormat='yyyy-MM-dd'
        monthsShown={2}
        calendarIconClassname='calendarIcon'
        showIcon
        selectsRange
        required
      />
    </div>
  );
}
